import { AUTH_URL } from '../../constants';

export const authEndpoints = {
  verify: () => `${AUTH_URL}/auth/verify`,
  googleAuth: (frontend: string) => `${AUTH_URL}/auth/google?frontend=${frontend}&sport=baseball&prompt=select_account`,
  register: () => `${AUTH_URL}/auth/register`,
  logout: () => `${AUTH_URL}/auth/logout`,
  login: () => `${AUTH_URL}/auth/login`,
  forgotPassword: () => `${AUTH_URL}/auth/reset-password`,
};

export function getAuthEndpoint(path: string) {
  return `${AUTH_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}

export { AUTH_URL }; 